import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faCheck,
  faUpload,
  faShirt,
  faPalette,
  faGear,
  faUser,
  faMagnifyingGlass,
  faLocationDot,
  faPhone,
  faEnvelope,
  faClock,
  faFilter,
  faMessage,
  faBars,
  faXmark,
  faCartShopping,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faTruck,
  faUsers,
  faAward,
  faBuilding,
  faGift,
  faTrophy,
  faGraduationCap,
  faIndustry,
  faEuroSign,
  faBolt,
  faHeart,
  faShieldHalved,
  faClipboardList,
  faClipboardCheck,
  faFileLines,
  faFileArrowUp,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faYoutube,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { forwardRef } from "react";

type Props = {
  className?: string;
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  "aria-hidden"?: boolean;
} & Omit<Partial<FontAwesomeIconProps>, "icon" | "size" | "color">;

const make = (icon: IconDefinition) =>
  forwardRef<SVGSVGElement, Props>(({ className, size, color, strokeWidth: _sw, ...rest }, ref) => {
    const style: React.CSSProperties = {};
    if (size !== undefined) {
      const v = typeof size === "number" ? `${size}px` : size;
      style.width = v;
      style.height = v;
    }
    if (color) style.color = color;
    return (
      <FontAwesomeIcon
        icon={icon}
        className={className}
        style={{ ...style, ...(rest.style || {}) }}
        ref={ref as never}
        {...rest}
      />
    );
  });


export const ArrowLeft = make(faArrowLeft);
export const ArrowRight = make(faArrowRight);
export const Check = make(faCheck);
export const Upload = make(faUpload);
export const ShirtIcon = make(faShirt);
export const Shirt = make(faShirt);
export const Palette = make(faPalette);
export const Settings2 = make(faGear);
export const User = make(faUser);
export const Search = make(faMagnifyingGlass);
export const MapPin = make(faLocationDot);
export const Phone = make(faPhone);
export const Mail = make(faEnvelope);
export const Clock = make(faClock);
export const Filter = make(faFilter);
export const MessageCircle = make(faWhatsapp);
export const Menu = make(faBars);
export const X = make(faXmark);
export const ShoppingCart = make(faCartShopping);
export const ChevronDown = make(faChevronDown);
export const ChevronLeft = make(faChevronLeft);
export const ChevronRight = make(faChevronRight);
export const CheckCircle2 = make(faCircleCheck);
export const Truck = make(faTruck);
export const Users = make(faUsers);
export const Award = make(faAward);
export const Building2 = make(faBuilding);
export const PartyPopper = make(faGift);
export const Trophy = make(faTrophy);
export const GraduationCap = make(faGraduationCap);
export const Factory = make(faIndustry);
export const BadgeEuro = make(faEuroSign);
export const Zap = make(faBolt);
export const Heart = make(faHeart);
export const ShieldCheck = make(faShieldHalved);
export const ClipboardList = make(faClipboardList);
export const ClipboardCheck = make(faClipboardCheck);
export const FileLines = make(faFileLines);
export const FileArrowUp = make(faFileArrowUp);
export const Star = make(faStar);
export const Facebook = make(faFacebookF);
export const Youtube = make(faYoutube);
export const Instagram = make(faInstagram);
export const Whatsapp = make(faWhatsapp);
